export interface ILocalStorage {
  getInstance<TModel>(ctor: { new(): TModel }): AbstractStorageService<TModel>;
}

export abstract class AbstractStorageService<TModel> {
  abstract every(predicate: (item: TModel) => boolean): Promise<boolean>;
  abstract some(predicate: (item: TModel) => boolean): Promise<boolean>;
  abstract find(predicate: (item: TModel) => boolean): Promise<TModel | undefined>;
  abstract filter(predicate: (item: TModel) => boolean): Promise<TModel[]>;
  abstract getAll(): Promise<TModel[]>;
  abstract addOne(item: TModel): Promise<TModel | null>;
  abstract upsertOne(predicate: (item: TModel) => boolean, item: TModel): Promise<TModel | null>;
  abstract addMany(_items: TModel[]): Promise<TModel[]>;
  abstract removeOne(predicate: (item: TModel) => boolean): Promise<TModel | undefined>;
  abstract removeMany(predicate: (item: TModel) => boolean): Promise<TModel[] | undefined>;
  abstract updateOne(predicate: (item: TModel) => boolean, item: TModel): Promise<TModel | undefined>;
  abstract clear(): Promise<boolean>;
}

